module.exports = __webpack_public_path__ + "img/charging-hub-disabled.32be9440.svg";